module.exports = __webpack_public_path__ + "img/52ad3ba0413f3922b9b727a119b57e7c.png";